// export async function getAllUsers() {

//     try{
//         const response = await fetch('/api/users');
//         return await response.json();
//     }catch(error) {
//         return [];
//     }
    
// }
import { setCookie } from 'cookies-next';

export async function createUser(data) {
    const response = await fetch(`https://qa.vinbytes.com/shankarIasTest/web/form/submit?formType=`+ data.formType , {
        method: 'POST',
        headers: {'Content-Type': 'application/json','Access-Control-Allow-Origin': '*'},
        body: JSON.stringify(data)
      })
      if (await !response.ok) {
        const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
      const responseData=await response.json();
      // console.log(responseData.data[0].id);
      setCookie('OtpToken', responseData.data[0].id,{secure: false,maxAge: 60 * 30,sameSite: "strict",path: "/"});
    return responseData;
}